export enum SalaryRuleOpenPeriodHandling {
UserValue,
DefinitionValue,
}
